// @ts-strict-ignore
import { ReportType } from 'constants/reports/report-type';
import { ApiManager } from 'services/api/api-manager';
import { type IActionWithPayload } from 'store/helper';

import { type IFetchReportPayload, type IReportRequest, ReportRequestName } from '../interfaces';

import { makeFetchingSaga } from './helpers';

export function* fetchSolvedTickets(action: IActionWithPayload<string, IFetchReportPayload>) {
  const requests: IReportRequest[] = [
    {
      name: ReportRequestName.SolvedTickets,
      interface: ApiManager.reportApi.fetchSolvedTickets,
    },
  ];

  yield makeFetchingSaga(ReportType.SolvedTickets, action, requests);
}
